/**
 * usePost Hook
 * Feature 014: Unified Multi-AI Post Generation Flow
 * T041: Query hook for accessing post data with multi-model support
 */

import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import { Id } from '../../convex/_generated/dataModel';

/**
 * T041: usePost Hook
 * Fetches post data and provides helpers for multi-model posts
 *
 * @param postId - Post ID to fetch
 * @returns Post data with loading state and multi-model helpers
 */
export function usePost(postId: Id<'posts'> | undefined) {
  const post = useQuery(
    api.posts.getPostByIdPublic,
    postId ? { postId } : 'skip'
  );

  const hasMultiModelPosts = !!post?.generatedPosts;
  const multiModelPosts = post?.generatedPosts || null;

  // Legacy posts use single-model fields (hook, problemSetup, etc.)
  // New posts use generatedPosts.claude/gemini/openai

  return {
    post,
    isLoading: post === undefined,
    notFound: postId ? post === null : false,
    hasMultiModelPosts,
    multiModelPosts,
  };
}
